import { useQuery } from '@tanstack/react-query';
import { agentClient } from '../../../../lib/connect/clients';
/**
 * Fetches project-scoped conversation history via shanks's
 * AgentService.ListHistory (browser → sabaody → shanks → pangaea). The
 * project filter is applied client-side because the AgentService
 * proto's ListHistory does not (yet) take a project_id; the response
 * lists all the caller's chats, then we narrow to the requested
 * projectId. The MVP proposal dashboard typically has <50 chats per
 * project so this is acceptable until ListHistory grows a server-side
 * filter.
 */ async function fetchProjectConversations(projectId) {
    const resp = await agentClient.listHistory({
        userId: '',
        limit: 10000,
        offset: 0
    });
    return resp.conversations.filter((c)=>c.projectId === projectId).map((c)=>{
        const createdAt = c.createdAt?.toDate().toISOString() ?? new Date(0).toISOString();
        const updatedAt = c.updatedAt?.toDate().toISOString() ?? createdAt;
        return {
            chatId: `shanks-${c.id}`,
            title: c.title,
            createdAt,
            updatedAt,
            projectId: c.projectId || undefined
        };
    }).sort((a, b)=>b.updatedAt.localeCompare(a.updatedAt));
}
export function useProjectConversations(projectId) {
    return useQuery({
        queryKey: [
            'project-conversations',
            projectId
        ],
        queryFn: ()=>fetchProjectConversations(projectId ?? ''),
        enabled: !!projectId,
        staleTime: 30000
    });
}
